import React, { useState } from "react";
import "./ContactPage.css";

import ContactHero from "../../components/ContactPage/ContactHero/ContactHero";
import ContactCardSection from "../../components/ContactPage/ContactCardSection/ContactCardSection";
import SoftCtaSection from "../../components/ContactPage/SoftCtaSection/SoftCtaSection";
const ContactPage = () => {
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const handleFormSuccess = () => {
    setIsFormSubmitted(true);
  };
  return (
    <div className="contact-page-wrapper">
      <ContactHero />

      {isFormSubmitted ? (
        <SoftCtaSection />
      ) : (
        <ContactCardSection onFormSuccess={handleFormSuccess} />
      )}
    </div>
  );
};

export default ContactPage;
